<div class="clr-row">
    <span class="spinner">
        Loading...
    </span>
</div>